import { Icon } from 'src/components/ui/icon';
import { Typography } from 'src/components/ui/typography';
import { sidebarIcons } from 'src/layouts/SidebarV2/icons';

export interface GroupHeaderProps {
  heading: string;
  expanded: boolean;
  onToggle: () => void;
}

// Header-only collapsible row (unlike SectionGroup, doesn't wrap children) —
// the virtualized list emits header and item rows separately.
const GroupHeader = ({ heading, expanded, onToggle }: GroupHeaderProps) => (
  <button
    type="button"
    onClick={onToggle}
    aria-expanded={expanded}
    className="tw:flex tw:items-center tw:gap-1 tw:w-full tw:px-s tw:py-2xs tw:rounded-full tw:border-0 tw:bg-transparent tw:cursor-pointer tw:text-left tw:hover:bg-secondary-hover"
  >
    <Typography
      variant="b3"
      align="left"
      colorClass="tw:text-text-secondary"
      className="tw:truncate"
    >
      {heading}
    </Typography>
    <Icon
      icon={expanded ? sidebarIcons.chevronDown : sidebarIcons.chevronRight}
      sizeClass="tw:w-m tw:h-m"
      colorClass="tw:text-icon-primary"
      className="tw:shrink-0"
    />
  </button>
);

export { GroupHeader };
